// src/pages/Test.jsx (veya .tsx)
import { Table } from "antd";
import { useEffect } from "react";

import SubscriptionTable from "src/components/subscription/SubscriptionTable"; // <-- HEP AYNI PATH'I KULLAN
import { LicensesProvider } from "src/reducers/subscription";
import SubscriptionDrawer from "../components/subscription/SubscriptionDrawer"; // <-- HEP AYNI PATH'I KULLAN


const Test = () => {
  return (
    <>
      <LicensesProvider>
        <SubscriptionTable />


        <SubscriptionDrawer />

      </LicensesProvider>


    </>
  );
};

export default Test;
